<template>
  <v-app>
    <v-content>
      <v-container fluid>
        <v-row justify="center">
          <v-col
            cols="10"
            style="height: 300px; align-self: center; background: white; border-radius: 12px;"
          >
            <div class="font-weight-bold text-h6 mb-4 text-center">Edit Machine Access</div>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="email"
                  label="Email"
                  outlined
                  :rules="[v => !!v || 'Email is required']"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="serialNumber"
                  label="Serial Number"
                  outlined
                  :rules="[v => !!v || 'Serial Number is required']"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field v-model="identifier" label="MaxControl Name
                 (How the Machine is displayed in user's list)" outlined></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="d-flex justify-center">
                <v-btn
                  color="info"
                  class="mr-4"
                  :disabled="isLoading || (!email && !serialNumber)"
                  @click="searchMachines"
                >
                  Search by {{ serialNumber ? 'Serial Number' : 'Email' }}
                </v-btn>
                <v-btn
                  :loading="isLoading"
                  :disabled="isLoading || !email || !serialNumber"
                  color="primary"
                  class="mr-4"
                  @click="addUser"
                >
                  Add To Machine
                </v-btn>
                <v-btn
                  color="error"
                  @click="removeUser"
                  :disabled="isLoading || !serialNumber"
                >
                  Remove From Machine
                </v-btn>
              </v-col>
            </v-row>
            <v-row v-if="machinesOwned.length || machinesOperated.length">
              <v-col cols="12">
                <div class="mt-2">
                  <template v-if="searchType === 'serial'">
                    <div class="subtitle-2 mb-1">Owner:</div>
                    <ul>
                      <li v-for="machine in Array.isArray(machinesOwned)
                       ? machinesOwned : [machinesOwned]" :key="machine">{{ machine }}</li>
                    </ul>
                    <div v-if="machinesOperated.length"
                    class="subtitle-2 mb-1">Operaters:</div>
                    <ul v-if="machinesOperated.length">
                      <li v-for="machine in machinesOperated" :key="machine">{{ machine }}</li>
                    </ul>
                  </template>
                  <template v-else>
                    <div v-if="machinesOwned.length" class="subtitle-2 mb-1">Owned Machines</div>
                    <ul v-if="machinesOwned.length">
                      <li v-for="machine in machinesOwned" :key="machine">{{ machine }}</li>
                    </ul>
                    <div v-if="machinesOperated.length"
                    class="subtitle-2 mb-1">Operated Machines</div>
                    <ul v-if="machinesOperated.length">
                      <li v-for="machine in machinesOperated" :key="machine">{{ machine }}</li>
                    </ul>
                  </template>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="text-center">
                <span :style="{ color: responseSuccess === true ? 'green'
                 : responseSuccess === false ? 'red' : '' }">
                  {{ responseMessage }}
                </span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import axios from 'axios';

export default {
  name: 'AdminScreen',
  data() {
    return {
      email: '',
      serialNumber: '',
      identifier: '',
      responseMessage: '',
      responseSuccess: null,
      isLoading: false,
      machinesOwned: [],
      machinesOperated: [],
      searchType: '',
    };
  },
  methods: {
    async searchMachines() {
      this.isLoading = true;
      this.responseMessage = '';
      this.machinesOwned = [];
      this.machinesOperated = [];
      if (this.serialNumber) {
        this.searchType = 'serial';
        try {
          const res = await axios.post(
            `${process.env.VUE_APP_BACKEND_URL}/commander/listOfOwnersAndOperators`,
            { serialNumber: this.serialNumber },
            { headers: { Authorization: localStorage.token } },
          );
          if (res.data && (Array.isArray(res.data.owned) || Array.isArray(res.data.operated))) {
            this.machinesOwned = res.data.owned || [];
            this.machinesOperated = res.data.operated || [];
            this.responseMessage = 'Owners and operators found.';
            this.responseSuccess = true;
          } else {
            this.responseMessage = res.data.message || 'No owners/operators found.';
            this.responseSuccess = false;
          }
        } catch (err) {
          this.responseMessage = err.response?.data?.message || 'Failed to search by serial number.';
          this.responseSuccess = false;
        } finally {
          this.isLoading = false;
        }
      } else if (this.email) {
        this.searchType = 'email';
        try {
          const res = await axios.post(
            `${process.env.VUE_APP_BACKEND_URL}/commander/getListOfMachinesByEmail`,
            { email: this.email },
            { headers: { Authorization: localStorage.token } },
          );
          if (res.data && (Array.isArray(res.data.owned) || Array.isArray(res.data.operated))) {
            this.machinesOwned = res.data.owned || [];
            this.machinesOperated = res.data.operated || [];
            this.responseMessage = 'Machines found.';
            this.responseSuccess = true;
          } else {
            this.responseMessage = res.data.message || 'No machines found.';
            this.responseSuccess = false;
          }
        } catch (err) {
          this.responseMessage = err.response?.data?.message || 'Failed to search by email.';
          this.responseSuccess = false;
        } finally {
          this.isLoading = false;
        }
      } else {
        this.responseMessage = 'Please enter an email or serial number.';
        this.responseSuccess = false;
        this.isLoading = false;
      }
    },
    async addUser() {
      this.isLoading = true;
      this.responseMessage = '';
      this.responseSuccess = null;
      try {
        const res = await axios.post(
          `${process.env.VUE_APP_BACKEND_URL}/commander/update-owner`,
          {
            email: this.email,
            serialNumber: this.serialNumber,
            identifier: this.identifier,
          },
          {
            headers: { Authorization: localStorage.token },
          },
        );
        this.responseMessage = res.data.message || 'User updated successfully.';
        this.responseSuccess = res.data.success !== false;
      } catch (err) {
        this.responseMessage = err.response?.data?.message || 'Failed to update user.';
        this.responseSuccess = false;
      } finally {
        this.isLoading = false;
      }
    },
    async removeUser() {
      this.isLoading = true;
      this.responseMessage = '';
      this.responseSuccess = null;
      try {
        const res = await axios.post(
          `${process.env.VUE_APP_BACKEND_URL}/commander/remove-owner`,
          {
            serialNumber: this.serialNumber,
          },
          {
            headers: { Authorization: localStorage.token },
          },
        );
        this.responseMessage = res.data.message || 'User removed successfully.';
        this.responseSuccess = res.data.success !== false;
      } catch (err) {
        this.responseMessage = err.response?.data?.message || 'Failed to remove user.';
        this.responseSuccess = false;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
/* Add any custom styles here */
</style>
